import { render, staticRenderFns } from "./NonsupportI18n.vue?vue&type=template&id=63865e9b&scoped=true"
import script from "./NonsupportI18n.vue?vue&type=script&lang=js"
export * from "./NonsupportI18n.vue?vue&type=script&lang=js"
import style0 from "./NonsupportI18n.vue?vue&type=style&index=0&id=63865e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63865e9b",
  null
  
)

export default component.exports